import React from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Box, Typography } from '@mui/material';
import { Block as BlockIcon } from '@mui/icons-material';

/**
 * Shown when client is inactive to block creating or uploading documents.
 * Use client?.isActive === false to show (treat undefined as active for backward compatibility).
 */
const InactiveClientAlert = ({ client, severity = 'warning' }) => {
  const { t, i18n } = useTranslation();
  const direction = i18n.dir();
  if (client?.isActive !== false) return null;

  return (
    <Box sx={{ mb: 2 }}>
      <Alert
        severity={severity}
        icon={<BlockIcon />}
        sx={{ alignItems: 'center' }}
        dir= {direction}
      >
        <Typography component="span" variant="body1">
          {t('ClientInactiveCannotCreateDocuments')}
        </Typography>
      </Alert>
    </Box>
  );
};

export default InactiveClientAlert;
